const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export interface Celebration {
    id: number;
    name: string;
    jobTitle: string;
    location: string;
    celebrationDate: string;
    type: "birthday" | "anniversary";
    yearsOfService?: number;
    photoUrl?: string;
}

export const getCelebrations = async (): Promise<Celebration[]> => {
    const response = await fetch(`${API_BASE_URL}/api/celebrations`);
    if (!response.ok) {
        throw new Error("Failed to fetch celebrations");
    }
    return response.json();
};